import {
  CompletedNeeds,
  DonateButtonLoader,
  Gallery,
  NeedList,
  Recommender,
  SharingContainer,
  Stats,
  Sticky,
} from 'ppp'
import { mountOnId, WirwunderLogoWhitener } from 'shared'

document.addEventListener('DOMContentLoaded', () => {
  mountOnId(Stats, 'ppp-stats')
  mountOnId(Sticky, 'ppp-sticky')
  mountOnId(NeedList, 'ppp-need-list')
  mountOnId(CompletedNeeds, 'ppp-completed-needs')
  mountOnId(Recommender, 'ppp-recommender')
  mountOnId(Gallery, 'ppp-gallery')
  mountOnId(SharingContainer, 'ppp-sharing')
  mountOnId(DonateButtonLoader, 'ppp-opinions-donate-button')
  mountOnId(WirwunderLogoWhitener, 'ppp-wirwunder-logo')

  if (typeof IntersectionObserver === 'function') {
    const observed = document.getElementById('ppp-sticky-anchor') as HTMLElement
    // sorry, IE https://caniuse.com/#feat=intersectionobserver
    new IntersectionObserver((entries) => {
      for (const entry of entries) {
        ;(entry.target.nextSibling as HTMLElement | null)?.toggleAttribute('stuck', !entry.isIntersecting)
      }
    }).observe(observed)
  }
})
